// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_t9-0";